var React = require('react');

function ClearBtn (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35787 11.6421 0 7.5 0C3.35787 0 0 3.35787 0 7.5C0 11.6421 3.35787 15 7.5 15ZM10.5892 4.41073C10.9147 4.73618 10.9147 5.26382 10.5892 5.58924L8.67851 7.5L10.5892 9.41073C10.9147 9.73618 10.9147 10.2638 10.5892 10.5892C10.2638 10.9147 9.73618 10.9147 9.41073 10.5892L7.5 8.67851L5.58924 10.5892C5.26382 10.9147 4.73618 10.9147 4.41073 10.5892C4.08531 10.2638 4.08531 9.73618 4.41073 9.41073L6.32149 7.5L4.41073 5.58924C4.08531 5.26382 4.08531 4.73618 4.41073 4.41073C4.73618 4.08531 5.26382 4.08531 5.58924 4.41073L7.5 6.32149L9.41073 4.41073C9.73618 4.08531 10.2638 4.08531 10.5892 4.41073Z","fill":"black"}));
}

ClearBtn.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = ClearBtn;

ClearBtn.default = ClearBtn;
